import React, { useContext, useEffect, useState } from "react";

import PageContainer from "../../components/PageGeneralContainer/PageGeneralContainer";
import SterilizerProgramTable from "./SterilizerProgramTable/SterilizerProgramTable.jsx";

import request from "../../utils/request.js";
import t from "../../utils/translation.js";
import LocalizationContext from "../../utils/LocalizationContext.js";

import SterilizerProgramForm from "./SterilizerProgramForm/SterilizerProgramForm.jsx";
import styles from "./SterilizerProgram.module.css";
import SterilizerProgramDetail from "./SterilizerProgramDetail/SterilizerProgramDetail.jsx";
import { getUserCompany } from "../../utils/sessionHandler.js";
import Redirect from "../../utils/Redirect";

const SterilizerProgram = ({ location }) => {
  const [companyMachineModels, setCompanyMachineModels] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [methods, setMethods] = useState([]);
  const [machineTypes, setMachineTypes] = useState();
  const [materialsType, setMaterialsType] = useState([]);
  const [modal, setModal] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    programName: "",
    sterilizerId: null,
    cicleTemperature: null,
    cicleTime: null,
    temperatureUnit: "Celsius",
    timeUnit: "Minutes"
  });
  const [sterilizerData, setSterilizerData] = useState({});
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage,setItemsPerPage] = useState("");
  const [currentPage, setCurrentPage] = useState("");
  const [packagesTypes, setPackagesTypes] = useState([])
  const [defaultValue, setDefaultValue] = useState([])
  const [sterilizers, setSterilizers] = useState([])

  const locale = useContext(LocalizationContext);
  const { state } = location;

  const clearForm = () => {
    setFormData({
      id: null,
      programName: "",
      sterilizerId: null,
      cicleTemperature: null,
      cicleTime: null,
      temperatureUnit: "Celsius",
      timeUnit: "Minutes"
    });
  };
  const getPackagesTypes = async () => {
    try {
      setLoading(true);
      const res = await request().get(`/api/sterilizerProgram?companyId=${getUserCompany().Id}`);
      setPackagesTypes(res.data);
      setTotalPages(res.data.totalPages)
    } catch (error) {
      console.error("Error fetching machine models:", error);
    } finally {
      setLoading(false);
    }
  };

  const getMaterials = async () => {
    try {
      setLoading(true);
      const res = await request().get("/api/Material");
      setMaterials(res.data);
    } catch (error) {
      console.error("Error fetching brands:", error);
    } finally {
      setLoading(false);
    }
  };

  const getMethods = async () => {
    try {
      setLoading(true);
      const res = await request().get("/api/method");
      setMethods(
        res.data.map((m) => ({
          value: m.id,
          name: m.name,
          machineType: m.machineType,
        }))
      );
    } catch (error) {
      console.error("Error fetching methods:", error);
    } finally {
      setLoading(false);
    }
  };

  const getMaterialsTypes = async () => {
    try {
      setLoading(true);
      const res = await request().get("/api/materialType");
      setMaterialsType(res.data);
    } catch (error) {
      console.error("Error fetching methods:", error);
    } finally {
      setLoading(false);
    }
  };


  const getParameters = async () => {
    try {
      const response = await request().get(`/api/parameter/charge`);

      const sterilizers = response.data.sterilizers.map((item) => ({
        value: item.sterilizerId,
        name: item.name,
      }));

      setSterilizers(sterilizers);
    } catch (error) {
      console.error("Error al obtener esterilizadores:", error);
    }
  };

  const handleAdd = () => {
    setModal(true);
};

  const handleClose = () => {
    setModal(false);
    clearForm();
  };

  const handleDetail = (data) => {
    setSterilizerData(data);
    setShowDetail(true);
  };

  const handleCloseDetail = () => {
    setShowDetail(false);
    setSterilizerData({});
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  
  const handleItemsPerPageChange = (items) => {
    setItemsPerPage(items);
  };


  useEffect(() => {
    getMaterials();
    getMethods();
    getMaterialsTypes();
    getParameters()
  }, []);

  useEffect(() => {
    getPackagesTypes();
  }, [itemsPerPage,currentPage]);
  return (
    <PageContainer 
    title={"Sterilizer Program"} 
    category={"packagesTypes"}
     backUrl={"/appsterilization"} 
    onClickBack={() =>
      Redirect({
        redirect: true,
        path: state.programRecord ? "appcreateloads" : "/appsterilization",
      })
      } 
    clickBack={true}>
      <div className={styles.container}>
        <SterilizerProgramTable
          packagesTypes={packagesTypes}
          getPackagesTypes={getPackagesTypes}
          handleData={setFormData}
          handleModal={setModal}
          handleDetail={handleDetail}
          loading={loading}
          totalPages={totalPages}
          onPageChange={handlePageChange} 
          onItemsPerPageChange={handleItemsPerPageChange}
        />
        <div className={styles.detailContainer}></div>
      </div>
      <button
        className={`${styles.button} ${styles.addButton}`}
        onClick={() => handleAdd()}
      >
        Add
      </button>

      {modal && (
        <SterilizerProgramForm
          formData={formData}
          handleFormData={setFormData}
          handleClose={handleClose}
          open={modal}
          getPackagesTypes={getPackagesTypes}
          machineTypes={machineTypes}
          methods={methods}
          t={t}
          locale={locale}
          companyModels={companyMachineModels}
          materials={materials}
          materialsType={materialsType}
          defaultValue={defaultValue}
          sterilizers={sterilizers}
        />
      )}

      <SterilizerProgramDetail
        open={showDetail}
        handleClose={handleCloseDetail}
        t={t}
        locale={locale}
        sterilizerData={sterilizerData}
      />
    </PageContainer>
  );
};

export default SterilizerProgram;